(function twainCaptureDirectiveModuleDefinition() {

    angular.module("TwainCapture")
           .directive("twainCapture", ['twainCapture', function (twainCapture) {
            return {
                template: "<div id=\"dwtcontrolContainer\"></div>",
                restrict: "E",
                scope: true,
                link: function ($scope, $element, $attrs, ctrl) {

                    twainCapture.register($element);

                    $scope.$on("$destroy", function () {
                        twainCapture.unregister($element);
                    });

                }
            };
        }]);

})();